import { render, staticRenderFns } from "./credit-card.vue?vue&type=template&id=3070eab4&"
import script from "./credit-card.vue?vue&type=script&lang=js&"
export * from "./credit-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports